module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('title', [_vm._v("\nMurder on the Cliffs")]), _c('link', {
    attrs: {
      "href": "css/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "css/page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space"
  }, [_vm._v("MURDER ON THE CLIFFS. Copyright © 2009 by Joanna Challis. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space"
  }, [_c('a', {
    attrs: {
      "href": "http://www.minotaurbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.minotaurbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space"
  }, [_vm._v("Library of Congress Cataloging- in- Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space"
  }, [_vm._v("Challis, Joanna.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Murder on the cliffs : a Daphne Du Maurier mystery / Joanna Challis.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN 978-0-312-36714-5")]), _vm._v(" "), _c('p', {
    staticClass: "copyright4"
  }, [_vm._v("1. Du Maurier, Daphne, 1907—1989—Fiction.2. Women authors, English—20th century—Fiction.3. Drowning victims—Fiction.4. Murder—Investigation— Fiction.5. Aristocracy (Social class)—England—Cornwall—Fiction. 6. Mansions—England—Cornwall—Fiction.7. Cornwall (England)—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("PR9619.4.C39M87 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("823.92—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space1"
  }, [_vm._v("2009028463")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space"
  }, [_vm._v("First Edition: December 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-space"
  }, [_vm._v("10   9   8   7   6   5   4   3   2   1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83235e9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 63
// module chunks = 0